import type { ReactNode } from 'react';
import { deprecate } from '../../utils/deprecate';
import type { MessageProps } from '../Message';
import { Message } from '../Message';

export interface NotificationProps {
  children: NonNullable<ReactNode>;
  type?: MessageProps['type'];
  centeredText?: MessageProps['centeredText'];
  onDelete?: MessageProps['onDismiss'];
}

/** @deprecated use Notification from kitt-universal instead */
export function Notification({ type, children, centeredText, onDelete }: NotificationProps): ReactNode {
  if (__DEV__) deprecate(Notification.name, 'Use Notification from kitt-universal instead');
  return (
    <Message noRadius type={type} centeredText={centeredText} onDismiss={onDelete}>
      {children}
    </Message>
  );
}
